var exports = {
  "kL": "x61f99309--6614f5--container",
  "Qq": "x61f99309--6614f5--text",
  "fP": "x61f99309--6614f5--attention",
};

module.exports = exports;
